import React from "react";
import AvailablePlugins from "../../components/AvailablePlugins";
import Button from "reusecore/src/elements/Button";
import { FiArrowRight } from "react-icons/fi";
import { navigate } from "gatsby";

export default {
  results: [
    {
      title: "Attention Map",
      content: [
        "Attention Maps are the perfect replacement for Five seconds tests and Eye Tracking studies.",
        "They help you understand how much time potential users will spend on your pages and show which parts of the page are most and least engaging by using a colored overlay."
      ],
      image: "/results/Attention Maps.png"
    },
    {
      title: "Areas of Interest",
      content: [
        "Areas of Interest, or AOI, let you create rectangular zones inside your artwork with critical elements inside them.",

        "By defining these areas, you get back useful statistics related to them, while identifying the perceived visual hierarchy of your elements. Therefore, you are able to quantify the Attentions Map's results and eliminate rough assumptions."
      ],
      image: "/results/Areas of Interest.png"
    },
    {
      title: "Clarity Score",
      content: [
        "Did you know users can judge a web site's credibility in as little as 3.42 seconds based on visual appearance alone?",
        "The Clarity Score can help you evaluate how clear and appealing your design is. It is generated based on large-scale studies with thousands of testers from across the globe, and gives a value from 0 to 100.",
        "The Clarity score can also be a perfect substitute for a quick Preference Test."
      ],
      image: "/results/Clarity Score.png"
    },
    {
      title: "Clarity Maps",
      content: [
        "Clarity Maps show you which areas of our design have a negative or a positive contribution to your Clarity Score. Areas highlighted in red are considered cluttered.",
        "If you want to improve clarity score on a specific design, this map will help you pinpoint which pixels could be removed or modified to generate some quick wins."
      ],
      image: "/results/Clarity Maps.png"
    }
  ]
};
